module.exports = __webpack_public_path__ + "fonts/Livory-Bold.woff2";